export const adminLabels = {
	DONT_ALLOW: 'You are not allowed to do this action.',
	MIN: 'Select at-least one option.',
	DELETE: 'Are you sure you want to delete this ',
	IMAGESHOW: ["image/jpeg", "image/jpg", "image/png"],
	VIDEOSHOW: ["video/mp4"],
	UPLOADED_IMAGES: 'Uploaded-Images',
	EDITOR: 'Editor',
	PRODUCTION_MANAGER: 'Production-Manager',
	QUALITY_ASSURANCE: 'Quality-Assurance',
}

export const s3Paths = {
	s3_main_url: process.env.REACT_APP_S3_PATH,
	s3_thumbnail_url: process.env.REACT_APP_S3_THUMBNAIL_PATH,
}



// WEBPACK FOOTER //
// ./src/redux/constant/admin-label-constant.jsx